// extracted by mini-css-extract-plugin
export default {"secaoprincipal":"CadastroGarcons_secaoprincipal__Nvzfs","plink":"CadastroGarcons_plink__L5i5X","btn":"CadastroGarcons_btn__kZzBV"};